'use client';

import { useEffect } from 'react';

// PWA plan: register the service worker in production, keep a single registration,
// and let the SW handle cache versioning/cleanup. UI can stay responsive while SW updates.
const SW_PATH = '/sw.js';

export function ServiceWorkerRegister() {
  useEffect(() => {
    const isClient = typeof window !== 'undefined';
    const supportsSw = isClient && 'serviceWorker' in navigator;
    if (!supportsSw) {
      return;
    }

    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const shouldRegister = process.env.NODE_ENV === 'production' || isLocalhost;

    if (!shouldRegister) {
      return;
    }

    const register = async () => {
      try {
        const registration = await navigator.serviceWorker.register(SW_PATH, { scope: '/' });

        // Listen for a waiting worker and trigger skipWaiting so updates apply faster.
        registration.addEventListener('updatefound', () => {
          const worker = registration.installing;
          if (!worker) {
            return;
          }
          worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              worker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });

        // Ensure the SW starts controlling asap (useful when opening from OS shortcut).
        await navigator.serviceWorker.ready;
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('Service worker registration failed', e);
        }
      }
    };

    register();
  }, []);

  return null;
}
